export class LocalStorageRepository<T extends { id: string }> {
    constructor(private storageKey: string) { }

    save(item: T): T {
        const items = this.findAll();
        const index = items.findIndex(i => i.id === item.id);

        if (index >= 0) {
            items[index] = item;
        } else {
            items.push(item);
        }

        localStorage.setItem(this.storageKey, JSON.stringify(items));
        return item;
    }

    saveAll(items: T[]): T[] {
        localStorage.setItem(this.storageKey, JSON.stringify(items));
        return items;
    }

    findById(id: string): T | null {
        const items = this.findAll();
        return items.find(item => item.id === id) || null;
    }

    findAll(): T[] {
        const items = localStorage.getItem(this.storageKey);
        return items ? JSON.parse(items) : [];
    }

    delete(id: string): void {
        const items = this.findAll().filter(item => item.id !== id);
        localStorage.setItem(this.storageKey, JSON.stringify(items));
    }

    deleteAll(items: T[]): void {
    }

          
    clear(): void {
        localStorage.removeItem(this.storageKey);
    }
}